import { CategoryType } from 'CommonData/poco/index';

export class CategoryTypesMapper {
    public static map(data: any): Array<CategoryType> {
        if (!data) {
            throw 'No data for mapper: CategoryTypesMapper';
        }

        if (!data.categoryTypes) {
            return [];
        }

        let categoryTypes: Array<CategoryType> = [];

        categoryTypes = data.categoryTypes
            .map((ct: any) => new CategoryType({
                key: ct.label,
                name: ct.label,
                sortOrder: ct.sortOrder,
                isModelCategory: ct.isModels
            }))
            .sort((a: CategoryType, b: CategoryType) => a.sortOrder - b.sortOrder);

        return categoryTypes;
    }
}